export const numnowrap = (str) => {
    return str.replace(/(\d+)\s(\d+)/g, '$1\u202F$2');
};
